import styled from 'styled-components'

const Content = styled.div`
  padding: 28px 32px 32px 32px;
  max-width: 595px;

  button {
    margin-right: 10px;
  }
`

export const s = { Content }
